import { render, staticRenderFns } from "./ChattingModal.vue?vue&type=template&id=11c5530d&scoped=true&"
import script from "./ChattingModal.vue?vue&type=script&lang=js&"
export * from "./ChattingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5530d",
  null
  
)

export default component.exports